import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { tap, withLatestFrom } from 'rxjs/operators';

import * as LinksStoreActions from './links-store.actions';
import { Store } from '@ngrx/store';
import { ContentService } from 'src/app/shared/services/content.service';
import { selectLinksLoaded } from './links-store.selectors';

@Injectable()
export class LinksStoreEffects {
    loadLinksStores$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(LinksStoreActions.loadLinks),
                withLatestFrom(this.store.select(selectLinksLoaded)),
                tap(([_, loaded]) => {
                    if (!loaded) {
                        this.contentService.getLinks().subscribe((data) => {
                            this.store.dispatch(
                                LinksStoreActions.loadLinksSuccess({
                                    data: data,
                                })
                            );
                        });
                    }
                })
            );
        },
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        private store: Store,
        private contentService: ContentService
    ) {}
}
